let lastChildChangeSource: string | null = null;

export const setChildChangeSource = (source: string) => {
  lastChildChangeSource = source;
};

export const getChildChangeSource = () => lastChildChangeSource;

export const clearChildChangeSource = () => {
  lastChildChangeSource = null;
};
